import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import React from "react";
import { SectionHeader } from "./header";
type Props = {
  headline?: string;
  text?: string;
  link?: React.ReactNode;
  hasHeaderData: boolean;
  children: [React.ReactNode];
};
export function Individual({
  headline,
  text,
  link,
  hasHeaderData,
  children
}: Props) {
  const [item] = children;
  return <_StyledDiv $_css={[{
    "position": "relative",
    "zIndex": "10",
    "display": "none",
    "@media (min-width: 1024px)": {
      "display": "block",
      "backgroundColor": "var(--bg-secondary)",
      "paddingLeft": "var(--spacing-xl)",
      "paddingRight": "var(--spacing-xl)",
      "paddingTop": "var(--spacing-2xl)",
      "paddingBottom": "var(--spacing-2xl)"
    }
  }]}>
      <_StyledDiv2 $_css2={[{
      "display": "flex",
      "gap": "var(--spacing-md)",
      "overflow": "hidden"
    }]}>
        {hasHeaderData && <_StyledDiv3 $_css3={[{
        "display": "flex",
        "width": "100%",
        "flexBasis": "33.333333%",
        "flexDirection": "column",
        "justifyContent": "space-between",
        "padding": "var(--spacing-xl)"
      }]}>
            <SectionHeader alignment="vertical" headline={headline} text={text} link={link} />
          </_StyledDiv3>}
        <_StyledDiv4 $_css4={[{
        "width": "100%"
      }, hasHeaderData ? {
        "flexBasis": "66.666667%"
      } : {
        "flexBasis": "100%"
      }]}>{item}</_StyledDiv4>
      </_StyledDiv2>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-zhk3vq-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-zhk3vq-1"
})`${p => p.$_css2}`;
var _StyledDiv3 = _styled3("div").withConfig({
  componentId: "sc-sf-zhk3vq-2"
})`${p => p.$_css3}`;
var _StyledDiv4 = /*#__PURE__*/_styled4("div").withConfig({
  displayName: "individual___StyledDiv4",
  componentId: "sc-rtdo8v-0"
})(["", ""], p => p.$_css4);